import React from 'react';
import { BUTTON_VARIANTS, Dialog } from 'cdk-radial';

const GenericDialog = ({
  isOpen,
  setIsOpen,
  dialogActions,
  dialogMessage, 
  setLoader
}: any) => {
  const handleClose = () => {
    setIsOpen(false);
    setLoader(false);
  };

  return (
    <div>
      <Dialog
        buttonsProps={[
          dialogActions,
          {
            id: 'dialog-step-3-action-2',
            onClick: handleClose,
            text: 'NO',
            variant: BUTTON_VARIANTS.PRIMARY
          }
        ]}
        id="dialog-3"
        isOpen={isOpen}
        onClose={handleClose}
        title="Are you sure you want to continue"
      >
        <span>{dialogMessage}</span>
      </Dialog>
    </div>
  );
};

export default GenericDialog;
